import React from 'react';
import styles from './styles.module.scss';
import { FaExclamationTriangle, FaTimes } from 'react-icons/fa';
import image from '../../assets/images/ios_tracking.png';

interface IosModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
  appName?: string; // Optional prop for app name
}

const IosModal: React.FC<IosModalProps> = ({ isOpen, onClose, onContinue, appName }) => {
  if (!isOpen) return null;
  
  // Default app name if not provided
  const defaultAppName = 'the app';
  const appNameToUse = appName || defaultAppName;

  // Stop propagation to prevent clicks from reaching backdrop
  const handleContentClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div 
      className={styles.modalBackdrop} 
      onClick={onClose} // Close when clicking the backdrop
    >
      <div 
        className={styles.modalContent} 
        onClick={handleContentClick}
      >
        <div className={styles.header}>
          <FaExclamationTriangle className={styles.warningIcon} />
          <h2 className={styles.title}>Tap "Allow" to get paid</h2>
          <button 
            className={styles.closeButton} 
            onClick={onClose}
            aria-label="Close dialog"
          >
            <FaTimes />
          </button>
        </div>
        <div className={styles.imageContainer}>
          <img src={image} alt="iOS Tracking Instructions" className={styles.iosImage} />
        </div>
        <div className={styles.iosModalText}>
          <p>
            After installing {appNameToUse}, tap "Allow" when prompted so we can track your progress and reward you. <br />
          </p>
        </div>

        <div className={styles.footer}>
          <button 
            className={styles.continueButton} 
            onClick={onContinue}
          >
            Continue 
          </button>
        </div>
      </div>
    </div>
  );
};

export default IosModal;